<template>
  <div class="group-select">
      <div class="group-select-title">
        <Title :title="$t('pc_biz_group_move_group' /* 移动分组 */)" @close="onCancel"></Title>
      </div>
      <div class="group-select-content">
        <span class="group-select-content__info">{{ $t('pc_biz_group_move_info',[selectedUserIds.value ? selectedUserIds.value.length : 0])/*`将选中的 ${} 人移动至：`*/}}</span>
        <div :class="{
            'group-select-content-new': true,
            'group-select-content-new--line': groupList.length,
          }">
          <span 
            :class="{
              'group-select-content-new__btn':true,
              'group-select-content-new__btn--active': groupId === 'new',
            }" 
            @click="onSelect('new')"
          >{{$t('pc_biz_group_add' /* 新的分组 */)}}</span>
        </div>
        <div class="group-select-content-list">
            <GroupList :group-list="groupList" :id="groupId" mode='select' @select="onSelect"></GroupList>
        </div>
      </div>
      <div class="group-select-footer">
          <Submit @cancel="onCancel" @submit="onSubmit"></Submit>
      </div>
  </div>
</template>

<script>
import { Input, Message } from 'yxt-pc';
import Title from './title.vue';
import Submit from './main/components/submit.vue';
import GroupList from './main/components/group-list.vue';

export default {
  components: {
    'yxt-input': Input,
    Title,
    Submit,
    GroupList
  },
  props: {
    memberList: {
      type: Array,
      require: true
    },
    groupList: {
      type: Array,
      require: true
    },
    back: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    leftMemberNum() {
      let total = this.memberList.length;
      for (let i = 0; i < this.groupList.length;i++) {
        total -= this.groupList[i].groupMemberList.length;
      }
      return total;
    }
  },
  inject: {
    setPage: {
      default: () => {}
    },
    selectedUserIds: {
      value: {
        default: []
      }
    },
    dragMember: {
      default: () => {}
    },
    selectGroup: {
      default: () => {}
    },
    close: {
      default: () => {}
    }
  },
  data() {
    return {
      memberNum: 6,
      groupNum: 7,
      groupId: ''
    };
  },
  mounted() {
    this.computeGroupNum();
  },
  methods: {
    computeMemberNum() {
      if (~~this.groupNum) {
        this.memberNum = Math.ceil(this.leftMemberNum / this.groupNum);
      } else {
        this.computeGroupNum();
      }
    },
    computeGroupNum() {
      if (!~~this.memberNum && !~~this.groupNum) {
        throw new Error('not expectation value');
      }
      if (this.memberNum) {
        this.groupNum = Math.ceil(this.leftMemberNum / this.memberNum);
      } else {
        this.computeMemberNum();
      }
    },
    onSelect(id) {
      this.groupId = id;
    },
    onSubmit() {
      if (this.back) {
        this.selectGroup(this.groupId === 'new' ? '' : this.groupId);
        return;
      }
      if (!this.groupId) {
        Message.error(this.$t('pc_biz_group_move_tip') /* 请先选择分组 */);
        return;
      }
      this.dragMember(this.groupId);
    },
    onCancel() {
      if (this.back) {
        this.close();
      } else {
        this.setPage('Main');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.group-select{
    width: 480px;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    user-select: none;
    -ms-user-select: none;

    &-title{
        padding: 16px 24px;
        border-bottom: 1px solid #E9E9E9 ;
        height: 56px;
        box-sizing: border-box;
    }
    &-content{
        display: flex;
        height: calc(100% - 122px);
        flex-direction: column;
        padding: 28px 24px;
        &__info{
            font-size: 14px;
            line-height: 26px;
            font-weight: bolder;
            color: #262626;
        }
        &-new{
          padding: 12px 0;

          &__btn{
            height: 38px;
            display: flex;
            align-items: center;
            padding: 0 15px 0 12px;
            color: #595959;
            border-radius: 4px;
            &:hover{
              background: #F5F5F5;
            }
          }
          &__btn--active{
            background: #F0F6FF !important;
            color: #436BFF;
          }
        }
        &-new--line{
          border-bottom: 1px solid #E9E9E9;
        }
        &-list{
            padding-top: 12px;
            height: calc(100% - 88px);
        }
    }
    &-footer{
        height: 56px;
        background: #FFFFFF;
        box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.08);
        width: 100%;
        display: flex;
        align-self: center;
        justify-content: end;
        padding: 12px;
    }
}
</style>
